/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FunctionComponent, Component } from 'react';
import { ZakekeEnvironment, ZakekeProvider } from 'zakeke-configurator-react';
import Viewer from '../pages/Viewer/Viewer';
import useStore from '../Store';
import { DialogsRenderer } from './dialogs/Dialogs';
import { TabProvider } from './Layout/DesignerContext';

interface ErrorBoundaryProps {}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<
  React.PropsWithChildren<ErrorBoundaryProps>,
  ErrorBoundaryState
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Log the error or send it to an error tracking service
    console.error('Error caught by error boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render a fallback UI here
      return <p>Something went wrong. Please try again later.</p>;
    }

    return this.props.children;
  }
}

const zakekeEnvironment = new ZakekeEnvironment();

const App: FunctionComponent<{}> = () => {
  const {
    isLoading,
    setPriceFormatter,
    setSelectedAttributeId,
    setSelectedGroupId,
    setSelectedStepId,
    isMobile,
    selectedGroupId,
    setIsMobile,
    setNotifications,
    setLastSelectedItem,
  } = useStore();

  return (
    <ErrorBoundary>
      <TabProvider>
        <ZakekeProvider environment={zakekeEnvironment}>
          <Viewer />
          <DialogsRenderer />
        </ZakekeProvider>
      </TabProvider>
    </ErrorBoundary>
  );
};

export default App;
